export const editorSettings = {
    worldSize:{width:50000.0, height:50000.0},
    pathSimplificationTolerance:2.0,
    pathSmoothTolerance:2.5,
    pathSimplificationMaxVertices:100,
    maxVertices:5000,
    gravityX:0,
    gravityY:10,
}
